module.exports = "<p>\n  deptenquirydetails-grid works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/deptenquirydetails/deptenquirydetails-grid/deptenquirydetails-grid.component.html
// module id = ./src/app/hrms/serviceregister/deptenquirydetails/deptenquirydetails-grid/deptenquirydetails-grid.component.html
// module chunks = main